import React,{useState} from 'react';
import classes from './Signup.module.css';
import {Link, Redirect} from 'react-router-dom';
import Spinner from '../main/Spinner/Spinner';
import {authenticate,isAuthenticated} from './authenticate';
import axios from 'axios';
import DefaultHeader from '../main/Layout/DefaultHeader';
import Navbar1 from '../main/Layout/Navbar1';
const Signin =(props)=> {

    const [values,setValues] = useState({
        email:"",
        password:"",
        error:"",
        loadding:false,
        redirectToReferrer:false
    })
    const {email,password,error,loadding,redirectToReferrer} =values;
    const user = isAuthenticated().data;
   
    const handlechange =name=>event=>{
       setValues({...values,error:false,[name]:event.target.value});
    };
    const handleSignInClickFb = () => {
        // Authenticate using via passport api in the backend
        // Open facebook login page
        // window.open("http://localhost:8000/api/auth/facebook", "_self")
        window.open("https://nhathuocvantien.herokuapp.com/api/auth/facebook", "_self")
        };
   

      const handleSignInClickGg = () => {
        // Authenticate using via passport api in the backend
        // Open facebook login page
        // window.open("http://localhost:8000/api/auth/google", "_self");//_self not move to another tap
        window.open("https://nhathuocvantien.herokuapp.com/api/auth/google", "_self");//_self not move to another tap
      };


    const clickSubmit=(event)=>{
        event.preventDefault();
        setValues({...values,error:false,loadding:true});
        const body={
            email:email,
            password:password,
        }
        axios.post('/signin',body)
        .then(data=>{
            authenticate(data,()=>{
                setValues({...values,email:"",password:"",redirectToReferrer:true});
            })
        }).catch(err=>{
            setValues({...values,error:err.response.data.message,loadding:false})
        })
    }

    const showError=()=>(
        <div className="alert alert-danger" style={{display:error?"":"none"}}>{error}</div>
        )
    const showLoadding = ()=>(
        loadding&&(<Spinner/>)
    )
    const showRedirect=()=>{
        if (redirectToReferrer)
         {
            if (user && user.user.role === 1) {
                return <Redirect to="/admin/dashboard" />;
            } else {
                return <Redirect to="/user/dashboard" />;
            }
        }
        if (isAuthenticated()) {
            return <Redirect to="/" />;
        }
    }


    const signInForm = ()=>(
       
       <div>
        <h4 className="card-title mt-3 text-center">Sign In</h4>
        <p className="text-center">Get started with your free account</p>
        <p>
            <button onClick ={handleSignInClickGg}  className = "btn btn-block btn-danger" > <i className="fab fa-google"></i>   Login via Google</button>
            <button onClick ={handleSignInClickFb} className={`btn btn-block ${classes.btnfacebook}`}> <i className="fab fa-facebook-f"></i>   Login via facebook</button>
        </p>
        <p className={classes.dividertext}>
            <span className="bg-light">OR</span>
        </p>
        <form>
        <div className="form-group input-group">
            <div className="input-group-prepend">
                <span className="input-group-text"> <i className="fa fa-envelope"></i> </span>
             </div>
            <input onChange={handlechange('email')} value={email} className="form-control" placeholder="Email address" type="email"/>
        </div> 
        
        <div className="form-group input-group">
            <div className="input-group-prepend">
                <span className="input-group-text"> <i className="fa fa-lock"></i> </span>
            </div>
            <input onChange={handlechange('password')} value={password} className="form-control" placeholder="Create password" type="password"/>
        </div>                                
        <div className="form-group">
            <button onClick={clickSubmit} className="btn btn-primary btn-block"> Login </button>
        </div>   
        <p className="text-center">Dont have an account? <Link to="/signup">Sign Up</Link> </p>                                                                 
    </form>
    </div>
    )
    return (
        <React.Fragment>
            <Navbar1/>
            <DefaultHeader/>
    <div className="container-fluid" >
        <br/>  
        <div className="row justify-content-md-center">
            <div className="col col-lg-6 col-md-6 col-xs-6">
                <div className={`${classes.Card} card`}>
                    <article className="card-body mx-auto col col-lg-9" style={{"width":"100%"}}>
                
                        {showError()}
                        {showLoadding()}
                        {showRedirect()}
                        {signInForm()}
                
                    </article>
                </div>
            </div>
        </div>
        <br/>  
    </div>
        </React.Fragment>
    );
}

export default Signin;